import type { ModelActionChatMessage } from '@app/api/ActionsHistory';
import type { RecommendReadOperation } from '@app/api/RecommendChat/types';

export const getRecommendMessageKey = (
  conversationId: string,
  messageId: string
): string => `${conversationId}:${messageId}`;

export const buildRecommendReadBatches = (
  messages: ModelActionChatMessage[],
  visibleKeys: Set<string>,
  excludedKeys: Set<string>,
  createOperationId: () => string
): RecommendReadOperation[] => {
  const byConversation = new Map<string, Set<string>>();

  for (const message of messages) {
    const metadata = message.RecommendChat;
    if (
      !metadata ||
      message.Direction !== 'in' ||
      metadata.origin !== 'client'
    ) {
      continue;
    }
    const key = getRecommendMessageKey(
      metadata.conversationId,
      metadata.messageId
    );
    if (
      !visibleKeys.has(key) ||
      excludedKeys.has(key) ||
      metadata.recipientState === 'read' ||
      metadata.staffReadPending
    )
      continue;

    const messageIds =
      byConversation.get(metadata.conversationId) ?? new Set<string>();
    messageIds.add(metadata.messageId);
    byConversation.set(metadata.conversationId, messageIds);
  }

  const operations: RecommendReadOperation[] = [];
  for (const [conversationId, messageIds] of byConversation) {
    const ids = Array.from(messageIds);
    for (let offset = 0; offset < ids.length; offset += 100) {
      operations.push({
        conversationId,
        messageIds: ids.slice(offset, offset + 100),
        operationId: createOperationId(),
      });
    }
  }

  return operations;
};
